module.exports = __webpack_public_path__ + "img/brainfit_2.4dc8d1f0.jpg";